/**
 * @fileoverview Route guard for pages that only make sense when signed out.
 * @description Redirects an already-authenticated visitor away from /login to their resolved
 * destination (see `resolveSignedInDestination` — sends a mustChangePassword user to
 * /change-password rather than their normal home route), instead of showing them the login form
 * again.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { Navigate, Outlet } from 'react-router'

import { resolveSignedInDestination } from '@/shared/lib/auth/resolve-home-route'
import { useAuth } from '@/shared/lib/auth/useAuth'

/**
 * @component
 */
function GuestRoute() {
  const { isAuthenticated, user } = useAuth()

  if (isAuthenticated) {
    return <Navigate to={resolveSignedInDestination(user)} replace />
  }

  return <Outlet />
}

export default GuestRoute
